import { AppState } from "../root.reducer";

export const isWorkspaceLoadingSelector = (state: AppState) => state.workspace.isLoading;
export const workspaceSelector = (state: AppState) => state.workspace.workspace;
export const ownershipWorkspaceSelector = (state: AppState) => state.workspace.ownershipWorkspace;
export const workspaceInvitationsSelector = (state: AppState) => state.workspace.workspaceInvitations;

export const workspaceErrorSelector = (state: AppState) => state.workspace.error;

export const workspaceDeleteConfirmationSelector = (state: AppState) => state.workspace.workspacesConfirmation;